import { createFileRoute } from '@tanstack/react-router';
import { FleetHub } from '@/features/fleet/FleetHub';

export const Route = createFileRoute('/_app/fleet')({ component: FleetHub });

// Flotta (Fleet) — modello HR enterprise v2. Anagrafica mezzo estesa + 9 sotto-risorse
// gestionali (assegnazioni, assicurazioni, revisioni, bolli, manutenzioni, costi, sinistri,
// multe, patenti), tutte CRUD JSON:API puro. Le prenotazioni mezzo stanno su vehicle-bookings.
